import * as z from "zod";

const AI_INTEGRATION_BEDROCK_PROVIDER_CONFIG_SCHEMA = z.object({
  region: z.string().trim().min(1),
  profiles: z.array(z.string().trim().min(1)).default([]),
});

export type AiIntegrationBedrockProviderConfig = z.infer<
  typeof AI_INTEGRATION_BEDROCK_PROVIDER_CONFIG_SCHEMA
>;

export const parseAiIntegrationBedrockProviderConfig = (
  providerConfig: unknown
): AiIntegrationBedrockProviderConfig | undefined => {
  const result = AI_INTEGRATION_BEDROCK_PROVIDER_CONFIG_SCHEMA.safeParse(providerConfig);

  return result.success ? result.data : undefined;
};

export const createAiIntegrationBedrockProviderConfig = (
  region: string,
  profiles: string[] = []
): AiIntegrationBedrockProviderConfig => ({
  region: region.trim(),
  profiles,
});
